ACC.autocomplete = {
  minChars: 4,
  _autoload: ['bindSearchAutocomplete', 'bindDisableSearch', 'bindHintClick'],

  bindSearchAutocomplete: function() {
    // extend the default autocomplete widget, to solve issue on multiple instances of the searchbox component
    $.widget('custom.yautocomplete', $.ui.autocomplete, {
      _create: function() {
        // get instance specific options form the html data attr
        var option = this.element.data('options');
        // set the options to the widget
        this._setOptions({
          minLength: option.minCharactersBeforeRequest,
          displayProductImages: option.displayProductImages,
          delay: option.waitTimeBeforeRequest,
          autocompleteUrl: option.autocompleteUrl,
          source: this.source,
          classes: {
            'ui-autocomplete': 'header-search__autocomplete'
          }
        });

        // call the _super()
        $.ui.autocomplete.prototype._create.call(this);
      },
      options: {
        cache: {}, // init cache per instance
        focus: function() {
          return false;
        }, // prevent textfield value replacement on item focus
        select: function(event, ui) {
          $('.nav-search-hint__entry,.nav-search-hint__query').text('');
          ui.item.value = ACC.sanitizer.sanitize(ui.item.value);
          window.location.href = ui.item.url;
        }
      },
      _resizeMenu: function() {
        var width = $('.ui-front').css('width');
        this.menu.element.outerWidth(width);
      },
      _renderItem: function(ul, item) {
        $(ul).addClass('dropdown-menu');
        var searchVal = item.searchTerm;
        var itemDup = ACC.sanitizer.sanitize(item.value);
        for (
          var pos = itemDup.toLowerCase().indexOf(searchVal);
          pos !== -1;
          pos = itemDup.toLowerCase().indexOf(searchVal, pos + searchVal.length)
        ) {
          itemDup =
            itemDup.substring(0, pos) +
            itemDup.substring(pos, pos + searchVal.length).bold() +
            itemDup.substring(pos + searchVal.length, itemDup.length);
        }

        var renderHtml = $('<a>')
          .addClass('nav-search-dropdown--anchor')
          .attr('href', item.url)
          .html(itemDup);

        return $("<li role='option'>")
          .data('item.autocomplete', item)
          .append(renderHtml)
          .appendTo(ul);
      },
      _renderMenu: function(ul, items) {
        var that = this;
        var countProduct = 0;
        $.each(items, function(index, item) {
          if (item.type === 'productResult') {
            if (countProduct === 0) {
              $(ul).append(
                "<li role='heading' class='nav-search-dropdown__header'>" +
                  item.searchType +
                  "</li><li role='separator' class='divider'></li>"
              );
              that._renderItemData(ul, item);
            } else if (countProduct === 4) {
              $(ul).append(
                "<li class='nav-search-dropdown__others nav-search-dropdown__header'>...</li>"
              );
            } else if (countProduct <= 3) {
              that._renderItemData(ul, item);
            }
            countProduct = countProduct + 1;
          }
        });
        var url =
          ACC.config.encodedContextPath +
          '/search?text=' +
          $('#js-site-search-input').val();
        if (items.length !== 0) {
          $(ul).append(
            "<li role='separator' class='divider'></li><li role='option'><a href='" +
              url +
              "' class='nav-search-dropdown__all'>Show all results</a></li>"
          );
        }
        $('.nav-search-entry').addClass('nav-search-entry--open');
        $('.nav-search-entry').removeClass('nav-search-entry--focus');
      },

      _close: function(event, ui) {
        $('.nav-search-remove').addClass('hidden');
        $('.nav-search-entry').removeClass('nav-search-entry--open');
        $('.nav-search-entry').addClass('nav-search-entry--focus');
        this._super(event, ui);
      },
      _search: function(event, ui) {
        this._super(event, ui);
      },
      source: function(request, response) {
        $('.nav-search-hint__entry,.nav-search-hint__query').text('');
        var self = this;
        var term = request.term.toLowerCase();

        $.getJSON(
          self.options.autocompleteUrl,
          { term: request.term },
          function(data) {
            var autoSearchData = [];
            if (data.suggestions != null && data.suggestions.length > 0) {
              var hint = data.suggestions[0].term;
              var querySubstr = hint.substr(term.length, hint.length);
              const origValue = $('.nav-search-entry').val();
              if (
                hint !== term &&
                (term + querySubstr).length <= hint.length &&
                origValue.length > 3
              ) {
                $('.nav-search-hint__entry').text($('.nav-search-entry').val());
                $('.nav-search-hint__query').text(querySubstr);
              }
            } else {
              $('.nav-search-hint__entry,.nav-search-hint__query').text('');
            }
            if (data.products !== null) {
              $.each(data.products, function(i, obj) {
                autoSearchData.push({
                  value: ACC.sanitizer.sanitize(obj.name),
                  code: obj.code,
                  desc: ACC.sanitizer.sanitize(obj.description),
                  manufacturer: ACC.sanitizer.sanitize(obj.manufacturer),
                  url: ACC.config.encodedContextPath + obj.url,
                  //Commenting below line as per EPST-10711 as we do not need price in autoSuggestions
                  //price: obj.price.formattedValue,
                  searchType: 'Products',
                  type: 'productResult',
                  index: i,
                  searchTerm: term,
                  image:
                    obj.images != null && self.options.displayProductImages
                      ? obj.images[0].url
                      : null // prevent errors if obj.images = null
                });
              });
            }
            return response(autoSearchData);
          }
        );
      }
    });

    var $search = $('.js-site-search-input');
    if ($search.length > 0) {
      $search.yautocomplete();
    }
  },

  bindDisableSearch: function() {
    $('#js-site-search-input').keyup(function(event) {
      var searchVal = event.target.value.toLowerCase();
      var pressedkey = event.key;
      var searchHint = `${$('.nav-search-hint__entry').text()}${$(
        '.nav-search-hint__query'
      ).text()}`;
      if (
        !(
          searchVal !== '' &&
          pressedkey !== 'Enter' &&
          searchVal.length >= ACC.autocomplete.minChars &&
          searchHint.indexOf(searchVal) != -1
        )
      ) {
        $('.nav-search-hint__entry,.nav-search-hint__query').text('');
      }
      $('#js-site-search-input').val(
        $('#js-site-search-input')
          .val()
          .replace(/^\s+/gm, '')
      );
      $('.js_search_button').prop('disabled', this.value == '' ? true : false);
    });
  },
  bindHintClick: function() {
    $('#js-site-search-input').click(function(event) {
      const cursorPos = event.target.selectionStart;
      const hintVal = `${$('.nav-search-hint__entry').text()}${$(
        '.nav-search-hint__query'
      ).text()}`;
      const origValue = $('.nav-search-entry').val();

      if (
        cursorPos === origValue.length &&
        origValue.length >= ACC.autocomplete.minChars &&
        hintVal.length > 0
      ) {
        $('.nav-search-entry').val(hintVal);
        const $search = $('.js-site-search-input');
        if ($search.length > 0) {
          $search.yautocomplete('search');
        }
      }
    });
  }
};
